<template>
	<div class="container mx-auto flex flex-col min-h-screen" id="app">
		<main-header />
		<router-view class="flex-grow"/>
	</div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'

export default {
	components: {
		'main-header': MainHeader
	}
}
</script>

<style lang="postcss">
html {
	scroll-padding-top: 118px;
	scroll-behavior: smooth;
}

body {
	background-color: #EEE;
}

#app {
	font-family: theme(fontFamily.body);
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: theme('colors.black-blue');
	font-size: 16px;
	text-align: center;
}

@media screen and (min-width: 640px) {
	#app {
		font-size: 18px;
	}
}
</style>
